import { render, staticRenderFns } from "./accountSecurity.vue?vue&type=template&id=354cc6b2&scoped=true"
import script from "./accountSecurity.vue?vue&type=script&lang=js"
export * from "./accountSecurity.vue?vue&type=script&lang=js"
import style0 from "./accountSecurity.vue?vue&type=style&index=0&id=354cc6b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354cc6b2",
  null
  
)

export default component.exports